<script>
  import { coffre } from "../../store/OpvcmStore";
  import { tabCouleurCardInfo } from "../conf";
  import CardInfo from "../../components/ihm/CardInfo.svelte";
  import { onMount } from "svelte";

  let listeData ;
  let cumulOpvcm = 0;

  /**
   *
   * @param data
   */
  const listOpvcm = (letype, data) => {
    let result = [];
    if ($coffre != undefined) {
      if (letype != "") {
        result = data.filter((el) => {
          return el.OP_TYPE_PLCMT == letype;
        });
      } else {
        result = $coffre;
      }

      //console.log("listOPvcm => ");
      //console.log(result);
    }
    return result;
  };


  /***
   * calcul cul montnat vte
   */
  const cumumMTVte = (montant) => {
    cumulOpvcm += parseFloat(montant);
    return "";
  };

/**
   *
   * @param letype
   * @param data
   */
  const chercher = (letype, data) => {
    cumulOpvcm = 0;
    listeData = listOpvcm(letype, data);
  };

    chercher("ASSV0", $coffre);

</script>

<div class="container">
<button
    on:click={chercher("", $coffre)}
    type="button"
    class="btn btn-primary btn-group-sm">All</button
>
    {#await listeData then data }

        <div class="card col-12">
            <table class="table-primary table-bordered border-primary emprunts">
                <tr>
                    <td>Nom</td>
                    <td>Mt_Vte</td>
                    <td>type</td>
                    <td>benef</td>
                </tr>
                {#each data as op}
                  {cumumMTVte(op.OP_MT_VTE)}
                <tr>
                    <td>{op.OP_NOM}</td>
                    <td style="text-align: right;">{new Intl.NumberFormat("fr-FR").format(
            Math.round(op.OP_MT_VTE)
        )}</td>
                    <td>{op.OP_TYPE_PLCMT}</td>
                    <td>{op.OP_BENEF}</td>
                </tr>
                    {/each}
            </table>

        </div>

        <div class="alert alert-success" role="alert">
        Total de la sélection = {new Intl.NumberFormat("fr-FR").format(
            cumulOpvcm
        )}
        </div>
    {/await}


</div>

<style>
  .emprunts {
    font-size: 0.75em;
  }
</style>
